import { featuresData } from '@/mocks/home';

export default function SectionFeatures() {
  return (
    <section
      id="features"
      className="py-16 md:py-20 bg-background-100"
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block text-xs font-medium text-primary-500 bg-primary-500/10 px-3 py-1 rounded-full mb-3">
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            平台优势
          </h2>
          <p className="text-sm text-foreground-400 mt-2">三大核心优势，打造极致观影体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {featuresData.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-200/70 rounded-xl border border-background-300/40 p-6 md:p-8 text-center group hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="w-16 h-16 mx-auto rounded-2xl bg-primary-500/10 flex items-center justify-center mb-5 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${feature.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-100 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-400 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}